import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './full-page-video-banner.component.scss';
var FullPageVideoBanner = /** @class */ (function (_super) {
    tslib_1.__extends(FullPageVideoBanner, _super);
    function FullPageVideoBanner(element) {
        return _super.call(this, element) || this;
    }
    FullPageVideoBanner.prototype.init = function () {
        this.buttonMute = this.element.querySelector('.full-page-video-banner__mute');
        this.video = this.element.querySelector('.js-video-trigger');
        if (this.element.querySelector('.full-page-video-banner__mute--icon')) {
            this.muteIcon = this.element.querySelector('.full-page-video-banner__mute--icon');
            this.muteText = this.element.querySelector('.full-page-video-banner__mute--text');
            this.muteTextFunction(this.muteText);
            var muteTextFunction_1 = this.muteTextFunction;
            var muteText_1 = this.muteText;
            window.addEventListener('resize', function (event) {
                muteTextFunction_1(muteText_1);
            });
        }
        if (document.querySelector('.header__alert')) {
            var alertBox_1 = document.querySelector('.header__alert');
            window.addEventListener('scroll', function (event) {
                if (window.scrollY > 50) {
                    alertBox_1.classList.add('d-none');
                }
                else {
                    alertBox_1.classList.remove('d-none');
                }
            });
        }
    };
    FullPageVideoBanner.prototype.bindEvents = function () {
        var _this = this;
        if (this.buttonMute) {
            this.buttonMute.addEventListener('click', function (e) {
                _this.toggleMute();
            });
        }
    };
    FullPageVideoBanner.prototype.muteTextFunction = function (muteText) {
        if (window.screen.width > 767) {
            muteText.innerHTML = "Click to mute/un-mute";
        }
        else {
            muteText.innerHTML = "Tap to mute/un-mute";
        }
    };
    FullPageVideoBanner.prototype.toggleMute = function () {
        this.video.muted = !this.video.muted;
        if (this.video.muted) {
            this.muteIcon.innerHTML = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t\t\t<g fill=\"none\" fill-rule=\"evenodd\" opacity=\".6\">\n\t\t\t\t\t<path d=\"M0 0h24v24H0z\"/>\n\t\t\t\t\t<path d=\"M13.4 2.2 15 3v18l-1.6.8L5.667 16H1V8h4.666L13.4 2.2zM16 4a8 8 0 1 1 0 16v-2a6 6 0 1 0 0-12zm-3 1L7 9.5v5l6 4.5V5zm3 2a5 5 0 0 1 0 10v-2a3 3 0 0 0 0-6zM5 10H3v4h2v-4z\" fill=\"#FFF\" fill-rule=\"nonzero\"/>\n\t\t\t\t</g>\n\t\t\t</svg>";
        }
        else {
            this.muteIcon.innerHTML = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t\t\t<defs>\n\t\t\t\t\t<linearGradient x1=\"50%\" y1=\"0%\" x2=\"50%\" y2=\"100%\" id=\"a\">\n\t\t\t\t\t\t<stop stop-color=\"#FFF\" offset=\"0%\"/>\n\t\t\t\t\t\t<stop stop-color=\"#FFF\" offset=\"100%\"/>\n\t\t\t\t\t</linearGradient>\n\t\t\t\t</defs>\n\t\t\t\t<g fill=\"none\" fill-rule=\"evenodd\" opacity=\".6\">\n\t\t\t\t\t<path d=\"M0 0h24v24H0z\"/>\n\t\t\t\t\t<path d=\"M13.4 2.2 15 3v18l-1.6.8L5.667 16H1V8h4.666L13.4 2.2zM13 5 7 9.5v5l6 4.5V5zm8.667 4L23 10.333 21.333 12 23 13.667 21.667 15 20 13.333 18.333 15 17 13.667 18.667 12 17 10.333 18.333 9 20 10.667 21.667 9zM5 10H3v4h2v-4z\" fill=\"url(#a)\" fill-rule=\"nonzero\"/>\n\t\t\t\t</g>\n\t\t\t</svg>";
        }
    };
    return FullPageVideoBanner;
}(Base));
export { FullPageVideoBanner };



//////////////////
// WEBPACK FOOTER
// ./components/full-page-video-banner/full-page-video-banner.component.ts
// module id = 335
// module chunks = 0